export const COLORS = {
  primary: '#FF4F90',
  secondary: '#00DEC4',
  information: '#4D6379',
  warning: '#C74FFF',
  grey: '#616161',
  text: '#4D6379',
};
